const {
  toggle,
  toggle: { get }
} = window.o_util;

export { get, toggle };
/*                               */
